import React from 'react'

import clsx from 'clsx'

import classes from './CardContent.module.scss'

/** @type {import("./types").default} */
const CardContent = ({ children, className, ...props }) => {
  return (
    <div className={clsx('CardContent', classes.root, className)} {...props}>
      {children}
    </div>
  )
}

export default CardContent
